export default __webpack_public_path__ + "static/media/showers.69226dd6.svg";